import gql from 'graphql-tag'
import { pickDeep } from '@/helpers'
import _ from 'lodash'

export default config => async payload => {
  const {
    client,
    table,
    alias = 'item',
    allowedFields,
    defaultOutput,
    defaultFragments
  } = config

  const {
    output = defaultOutput,
    fragments = defaultFragments || '',
    where
  } = payload

  const mutation = gql`
     mutation($input: ${table}_set_input, $where: ${table}_bool_exp!) {
        ${alias}: update_${table}(where: { _and: [$where] }, _set: $input) {
          returning {
            ${output}
          }
        }
      }
      ${fragments}
    `

  const input = !_.isEmpty(allowedFields)
    ? pickDeep(payload, allowedFields)
    : payload

  const { data } = await client.mutate({
    mutation,
    variables: { where, input }
  })

  return data[alias]
}
